module.exports = __webpack_public_path__ + "img/SOS.8b65ef20.svg";